// extracted by mini-css-extract-plugin
module.exports = {"asideBox":"aside-box-module--aside-box--3ELKq","fakeButton":"aside-box-module--fake-button--2psir button-module--button--1y9IM"};